module.exports = __webpack_public_path__ + "static/media/student26.a0441b5e.png";